import { P } from "../../styles/tokens";

export default function DukyAvatar({ size = 36, animated = false }) {
  return (
    <div
      className={animated ? "duky-bounce" : ""}
      style={{
        width: size, height: size, borderRadius: "50%",
        background: `linear-gradient(135deg, ${P.ingresos.base}, #089558)`,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: size * 0.55, flexShrink: 0,
      }}
    >
      🐿️
    </div>
  );
}
